import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStravaComponent } from './simple-icons-strava.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStravaComponent ],
    exports:      [ SimpleIconsStravaComponent ],
    bootstrap:    []
})
export class SimpleIconsStravaModule {}
